'use strict';

// EXPORTS //

module.exports = require( './copy.js' );
